'use client';

import useRouteLogin from '@/ueshook/useRouteLogin';
import { Button } from '@/components/ui/button';
import useRoute from '@/ueshook/useRoute';
import { useUserInfo } from '@/provider/UserInfoProvider';
import { usePathname } from 'next/navigation';

function GradientBg() {
  return (
    <div className='absolute bottom-0 left-0 right-0 top-0'>
      <div
        className='absolute -left-[66.33%] -top-1 aspect-square w-[133.67%] rotate-[90deg] rounded-full blur-[100px] md:-left-[11.60%] md:-top-[223px] md:w-[76.94%] md:blur-[250px]'
        style={{
          backgroundImage:
            'linear-gradient(227deg, rgba(220, 153, 212, 0.50) 12.29%, rgba(0, 43, 255, 0.50) 83.23%)',
          transform: 'translate3d(0,0,0)',
        }}
      ></div>
      <div
        className='absolute -right-[67.35%] top-[130px] aspect-square w-[109.18%] rotate-0 rounded-full blur-[100px] md:-right-[24.31%] md:top-[60px] md:w-[62.71%] md:blur-[250px]'
        style={{
          backgroundImage:
            'linear-gradient(187deg, rgba(255, 93, 142, 0.80) 3.9%, rgba(132, 0, 126, 0.80) 35.45%, rgba(255, 0, 0, 0.64) 57.94%, rgba(255, 214, 117, 0.80) 84.57%)',
        }}
      ></div>
      <div
        className='absolute -top-[31px] left-[11.22%] aspect-square w-[102.04%] rounded-full blur-[100px] md:-top-[280px] md:left-[16.67%] md:right-[24.51%] md:w-[58.75%] md:blur-[250px]'
        style={{
          backgroundImage:
            'linear-gradient(184deg, rgba(255, 93, 142, 0.50) 64.92%, rgba(158, 71, 151, 0.50) 95.53%)',
        }}
      ></div>
    </div>
  );
}

interface JoinUsProps {
  translations?: {
    title: string;
    button: string;
  };
}

export default function JoinUs({ translations }: JoinUsProps) {
  const title =
    translations?.title || 'Join and unlock the full potentials of Kaze AI';
  const buttonText = translations?.button || 'Start free trial';
  const pathname = usePathname();
  const { userIdentity } = useUserInfo();
  const { routerLogin } = useRouteLogin();
  const { push } = useRoute();

  // 标题简单分割以适应布局
  const titleParts = {
    mobile: {
      line1: title.split(' ').slice(0, 3).join(' '),
      line2: title.split(' ').slice(3, 6).join(' '),
      line3: title.split(' ').slice(6).join(' '),
    },
    desktop: {
      line1: title.split(' ').slice(0, 5).join(' '),
      line2: title.split(' ').slice(5).join(' '),
    },
  };

  return (
    <section className='section-container relative mb-0 flex h-96 flex-col items-center justify-center overflow-hidden lg:mt-20'>
      {/* H5 */}
      <div className='z-10 h-56 w-full lg:hidden'>
        <div className='flex flex-col items-center justify-center space-y-0'>
          <h1 className='text-3xl font-bold text-stone-950'>
            {titleParts.mobile.line1}
          </h1>
          <h1 className='bg-clip-text text-3xl font-bold text-stone-950'>
            {titleParts.mobile.line2}
          </h1>
          <h1 className='bg-clip-text text-3xl font-bold text-stone-950'>
            {titleParts.mobile.line3}
          </h1>
        </div>

        <div className='mt-12 flex h-16 justify-center'>
          <Button
            onClick={() => {
              if (userIdentity === 3) {
                if (pathname === '/watermark-removal') {
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                } else {
                  push('/watermark-removal');
                }
              } else {
                routerLogin(() => push('/watermark-removal'));
              }
            }}
            className='mt-4 h-12 bg-black text-base text-white hover:bg-black/80'
          >
            {buttonText}
          </Button>
        </div>
      </div>

      {/* PC */}
      <div className='z-10 hidden h-56 lg:block'>
        <div className='flex flex-col items-center space-y-0'>
          <h1 className='text-6xl font-bold text-stone-950'>
            {titleParts.desktop.line1}
          </h1>
          <h1 className='bg-clip-text text-6xl font-bold text-stone-950'>
            {titleParts.desktop.line2}
          </h1>
        </div>

        <div className='mt-12 flex h-16 justify-center'>
          <Button
            onClick={() => {
              if (userIdentity === 3) {
                if (pathname === '/watermark-removal') {
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                } else {
                  push('/watermark-removal');
                }
              } else {
                routerLogin(() => push('/watermark-removal'));
              }
            }}
            className='mt-4 h-12 bg-black text-base text-white hover:bg-black/80'
          >
            {buttonText}
          </Button>
        </div>
      </div>

      <GradientBg />
    </section>
  );
}
